import { msg } from '@lingui/core/macro';

import { defineFilters } from '@/shared/filters/define-filters';

// Filtros da lista declarados uma vez (P01): o `FilterProvider` de `AutomaticSplitListContainer.tsx:76-96`
// e o formulário de `components/DataTableFilters/AutomaticSplitFilters/*`. Os nomes do fio são os do legado.
export const automaticSplitFilters = defineFilters([
  { key: 'searchString', type: 'search', label: msg`Todos`, placeholder: msg`Filtrar por todos` },
  { key: 'f_creditorName', type: 'text', label: msg`Credor` },
  { key: 'f_borrowerName', type: 'text', label: msg`Tomador` },
  { key: 'f_account', type: 'text', label: msg`Conta Escrow` },
]);
